module.exports = __webpack_public_path__ + "img/nest-2.31acd2df.png";